/* Nuvō search dropdown (Nov 1 2026), loaded site-wide from sections/nuvo-brand-styles.liquid.
   One panel serves every search field: the home hero pill, the header search and the phone search.
   Empty field: popular searches as keyword chips, plus the four collections.
   Typing: Shopify predictive search (/search/suggest.json) as suggested searches, roomy product rows,
   collections, and "View all results". The theme's own cramped results grid is hidden in nuvo-search-panel.css. */
(() => {
  const POPULAR = ['Fire pits', 'Fire bowls', 'Fire tables', 'Fire & water bowls', 'Torches', 'Water features',
    'BBQ islands', 'Pizza oven', 'Santa Maria grill', 'Fire glass', 'Hammered copper'];
  const CATS = [['Fire Features', '/collections/fire-features'], ['Outdoor Kitchens', '/collections/outdoor-kitchens'],
    ['Water Features', '/collections/water-features'], ['Fire Media & Accessories', '/collections/fire-media-accessories']];
  const ICON_SEARCH = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="5.5"/><path d="m13 13 4 4"/></svg>';
  const ICON_ARROW = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M11 5l5 5-5 5"/></svg>';

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const clean = (t) => String(t).split(' | ')[0];
  const money = (v) => '$' + Math.round(+v).toLocaleString('en-US');
  const sized = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  /* the typed text in bold inside a suggestion */
  const mark = (text, q) => {
    const i = text.toLowerCase().indexOf(q.toLowerCase());
    if (!q || i < 0) return esc(text);
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  };
  const searchUrl = (q) => '/search?type=product&q=' + encodeURIComponent(q);

  const panel = document.createElement('div');
  panel.className = 'nsr';
  panel.id = 'nsr-panel';
  panel.hidden = true;
  panel.setAttribute('role', 'listbox');
  panel.setAttribute('aria-label', 'Search suggestions');
  document.body.appendChild(panel);

  let input = null, timer = null, ctrl = null, active = -1, shownFor = null;

  const isField = (el) => el && el.matches && el.matches('input[name="q"]') && !el.closest('.nsr');
  const vh = () => (window.visualViewport ? window.visualViewport.height : window.innerHeight);

  /* the panel hangs under the field (its pill or form), as wide as the field but never cramped */
  const place = () => {
    if (!input || panel.hidden) return;
    /* the hero pill is the form itself; in the header the form spans more than the field, so follow the field */
    const form = input.closest('form');
    const fieldBox = input.getBoundingClientRect();
    const box = form && form.getBoundingClientRect().width < fieldBox.width * 1.4 ? form.getBoundingClientRect() : fieldBox;
    const vw = document.documentElement.clientWidth;
    const w = vw < 750 ? vw - 24 : Math.min(Math.max(box.width, 520), vw - 24, 600);
    const left = Math.max(12, Math.min(box === fieldBox ? box.left - 8 : box.left + (box.width - w) / 2, vw - w - 12));
    panel.style.top = Math.round(box.bottom + 10) + 'px';
    panel.style.left = Math.round(left) + 'px';
    panel.style.width = Math.round(w) + 'px';
    panel.style.maxHeight = Math.max(220, Math.round(vh() - box.bottom - 22)) + 'px';
  };

  const open = (el) => {
    input = el;
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'true');
    input.setAttribute('autocomplete', 'off');
    if (panel.hidden) { panel.hidden = false; panel.classList.remove('nsr--in'); void panel.offsetWidth; panel.classList.add('nsr--in'); }
    /* a field low on the screen (the hero pill) moves up so the suggestions have room */
    const r = input.getBoundingClientRect();
    if (r.top > vh() * 0.5) window.scrollBy({ top: r.top - Math.min(140, vh() * 0.18), behavior: 'smooth' });
    run(input.value.trim());
    place();
  };
  const close = () => {
    if (panel.hidden) return;
    panel.hidden = true;
    active = -1;
    shownFor = null;
    if (input) input.setAttribute('aria-expanded', 'false');
  };

  const items = () => [...panel.querySelectorAll('.nsr__item')];
  const setActive = (i) => {
    const list = items();
    active = list.length ? (i + list.length) % list.length : -1;
    list.forEach((el, n) => { el.classList.toggle('is-active', n === active); el.setAttribute('aria-selected', String(n === active)); });
    if (list[active]) list[active].scrollIntoView({ block: 'nearest' });
  };

  const chips = (words, cls = '') => '<div class="nsr__chips">' + words.map((k) =>
    `<button type="button" class="nsr__chip nsr__item ${cls}" data-q="${esc(k)}">${esc(k)}</button>`).join('') + '</div>';

  const renderIdle = () => {
    panel.innerHTML =
      '<div class="nsr__sec"><p class="nsr__h">Popular searches</p>' + chips(POPULAR) + '</div>' +
      '<div class="nsr__sec"><p class="nsr__h">Shop by collection</p><ul class="nsr__cats">' +
      CATS.map(([t, u]) => `<li><a class="nsr__cat nsr__item" href="${u}">${esc(t)}<span>${ICON_ARROW}</span></a></li>`).join('') + '</ul></div>';
  };

  const renderResults = (q, res) => {
    const queries = (res.queries || []).filter((s) => s.text.toLowerCase() !== q.toLowerCase()).slice(0, 4);
    const products = (res.products || []).slice(0, 6);
    const cols = (res.collections || []).slice(0, 3);
    let html = '';
    if (queries.length) {
      html += '<div class="nsr__sec"><p class="nsr__h">Suggestions</p><ul class="nsr__qs">' + queries.map((s) =>
        `<li><button type="button" class="nsr__q nsr__item" data-q="${esc(s.text)}">${ICON_SEARCH}<span>${mark(s.text, q)}</span></button></li>`).join('') + '</ul></div>';
    }
    if (products.length) {
      html += '<div class="nsr__sec"><p class="nsr__h">Products</p><ul class="nsr__ps">' + products.map((p) => {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        const from = p.price_min && p.price_max && +p.price_min !== +p.price_max;
        return `<li><a class="nsr__p nsr__item" href="${esc(p.url)}">` +
          `<span class="nsr__p-img">${img ? `<img src="${esc(sized(img, 160))}" alt="" loading="lazy">` : ''}</span>` +
          `<span class="nsr__p-txt">${p.type ? `<span class="nsr__p-type">${esc(p.type.replace('Fire Pits & Tables', 'Fire Tables'))}</span>` : ''}` +
          `<span class="nsr__p-title">${mark(clean(p.title), q)}</span></span>` +
          `<span class="nsr__p-price">${from ? '<small>From</small>' : ''}${money(p.price_min || p.price)}</span></a></li>`;
      }).join('') + '</ul></div>';
    }
    if (cols.length) {
      html += '<div class="nsr__sec"><p class="nsr__h">Collections</p><ul class="nsr__cats">' + cols.map((c) =>
        `<li><a class="nsr__cat nsr__item" href="${esc(c.url)}">${esc(c.title)}<span>${ICON_ARROW}</span></a></li>`).join('') + '</ul></div>';
    }
    if (!html) {
      html = `<div class="nsr__sec"><p class="nsr__none">No pieces match “${esc(q)}”. Try one of these:</p>${chips(POPULAR.slice(0, 6))}</div>`;
    }
    html += `<a class="nsr__all nsr__item" href="${searchUrl(q)}">View all results for “${esc(q)}”<span>${ICON_ARROW}</span></a>`;
    panel.innerHTML = html;
  };

  const run = (q) => {
    clearTimeout(timer);
    if (q === shownFor) return;
    if (!q) { shownFor = q; active = -1; renderIdle(); return; }
    timer = setTimeout(() => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      panel.classList.add('nsr--loading');
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=query,product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last`, { signal: ctrl.signal })
        .then((r) => r.json())
        .then((data) => {
          if (!input || input.value.trim() !== q) return;
          shownFor = q;
          active = -1;
          renderResults(q, (data.resources && data.resources.results) || {});
          place();
        })
        .catch(() => {})
        .finally(() => panel.classList.remove('nsr--loading'));
    }, 160);
  };

  /* a keyword chip or suggestion fills the field and searches it right away */
  const pick = (word) => {
    if (!input) return;
    input.value = word;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
    run(word);
  };

  document.addEventListener('focusin', (e) => { if (isField(e.target)) open(e.target); });
  document.addEventListener('input', (e) => { if (isField(e.target)) { if (input !== e.target || panel.hidden) open(e.target); else run(e.target.value.trim()); } });
  document.addEventListener('keydown', (e) => {
    if (!isField(e.target) || panel.hidden) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); e.stopPropagation();
      setActive(active + (e.key === 'ArrowDown' ? 1 : -1));
    } else if (e.key === 'Enter' && active >= 0 && items()[active]) {
      e.preventDefault(); e.stopPropagation();
      items()[active].click();
    } else if (e.key === 'Escape') {
      close();
    }
  }, true);

  panel.addEventListener('mousedown', (e) => { if (e.target.closest('button')) e.preventDefault(); });
  panel.addEventListener('click', (e) => {
    const b = e.target.closest('button[data-q]');
    if (b) { e.preventDefault(); pick(b.dataset.q); }
  });
  document.addEventListener('pointerdown', (e) => {
    if (panel.hidden || panel.contains(e.target) || isField(e.target)) return;
    close();
  });
  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', place);
  window.addEventListener('pageshow', close);
})();
